import { type MaintenanceOption, MaintenanceRequester } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import Alert from '@cobliteam/ui/components/Alert';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { loadPastMaintenancesRequest } from '../PastMaintenances/actionCreators';
import { loadUpcomingMaintenancesRequest } from '../UpcomingMaintenances/actionCreators';
import { loadMaintenanceItemOptionsFailed, loadMaintenanceItemOptionsSucceeded } from './actionCreators';
import type { DeleteMaintenanceRequest, SaveMaintenanceMarkedAsDoneRequest, SaveMaintenanceRegistryRequest } from './actions';
import { ActionTypes } from './actionTypes';

const env = Environment.getInstance().getEnvironment();

export const maintenanceRequester = new MaintenanceRequester({
  host: env.herbieApiHost,
});

export function* requestMaintenanceItemOptionsSaga() {
  try {
    const items: MaintenanceOption[] = yield call(maintenanceRequester.loadMaintenanceItemOptions);
    yield put(loadMaintenanceItemOptionsSucceeded(items));
  } catch (err) {
    yield put(loadMaintenanceItemOptionsFailed());
    Alert.error('Falha ao carregar itens de manutenção. Tente novamente mais tarde.');
  }
}

export function* requestDeleteMaintenanceSaga(action: DeleteMaintenanceRequest) {
  try {
    yield call(maintenanceRequester.deletePastMaintenance, action.payload);
    Alert.success('Manutenção deletada com sucesso!');
    if (action.payload.periodFilterApplied) {
      yield put(loadPastMaintenancesRequest());
    }
  } catch (err) {
    Alert.error('Falha ao deletar manutenção.');
  }
}

export function* requestSaveMaintenanceMarkedAsDoneSaga(action: SaveMaintenanceMarkedAsDoneRequest) {
  try {
    yield call(maintenanceRequester.markPastMaintenanceAsDone, action.payload);
    Alert.success('Manutenção salva com sucesso!');
    yield put(loadUpcomingMaintenancesRequest());
  } catch (err) {
    Alert.error('Falha ao salvar manutenção.');
  }
}

export function* requestSaveMaintenanceRegistrySaga(action: SaveMaintenanceRegistryRequest) {
  try {
    yield call(maintenanceRequester.savePastMaintenance, action.payload);
    Alert.success('Manutenção salva com sucesso!');
    if (action.payload.periodFilterApplied) {
      yield put(loadPastMaintenancesRequest());
    }
  } catch (err) {
    Alert.error('Falha ao salvar manutenção.');
  }
}

export function* RegisterMaintenanceSagasListener() {
  yield all([
    takeLatest(ActionTypes.LOAD_MAINTENANCE_ITEM_OPTIONS_REQUEST, requestMaintenanceItemOptionsSaga),
    takeLatest(ActionTypes.DELETE_MAINTENANCE_REQUEST, requestDeleteMaintenanceSaga),
    takeLatest(ActionTypes.SAVE_MAINTENANCE_MARKED_AS_DONE_REQUEST, requestSaveMaintenanceMarkedAsDoneSaga),
    takeLatest(ActionTypes.SAVE_MAINTENANCE_REGISTRY_REQUEST, requestSaveMaintenanceRegistrySaga),
  ]);
}
